import React from "react";
import { Box, useTheme, alpha } from "@mui/material";
import HelpPage from "./components/help";

const AboutComingSoonPage: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        pt: { xs: 12, md: 16 },
        pb: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: `linear-gradient(135deg, ${alpha(
          theme.palette.background.default,
          0.8
        )}, ${alpha(theme.palette.background.paper, 0.9)})`,
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `radial-gradient(circle at 20% 80%, ${alpha(
            theme.palette.primary.main,
            0.1
          )} 0%, transparent 50%),
                      radial-gradient(circle at 80% 20%, ${alpha(
                        theme.palette.secondary.main,
                        0.1
                      )} 0%, transparent 50%)`,
          pointerEvents: "none",
        },
      }}
    >
      <HelpPage />
    </Box>
  );
};

export default AboutComingSoonPage;
